module.exports = __webpack_public_path__ + "static/Aarakocra-7d5ee1e0a7a75a68736c500d4082757e.jpg";